import { LoadType } from '@tencent/ark-extensions';

/**
 * 超容提示弹框
 */
export default {
    name: 'docs-component-storage-overflow-alert',
    loadType: LoadType.ON_DEMAND,
};
